import * as Dtos from '../../dtos/Tmd.dtos';
import { IFieldState, IRegistrationFormState } from "./index";

export const initialTrialGroupItemTemplateState: Dtos.TrialGroupItemTemplate & IRegistrationFormState = {
    id: null,
    name: null,
    description: null,
    rank: null,
    trialGroupItemTemplateCategoryId: null,
    trialGroupItemTemplateCategory: null,
    groupId: null,
    group: null,
    allowIntraVersions: null,
    pendingDelete: null,
    allowVersionChanges: null,
    initialVersion: null,
    collectionId: null,
    collection: null,
    active: null,
    dateEntered: null,
    dateModified: null,
    enteredBy: null,
    modifiedBy: null,
    saveAndReturn: false,
}

export interface ITrialGroupItemTemplateReduxFormState {
    id: IFieldState<number>,
    name: IFieldState<string>,
    description: IFieldState<string>,
    rank: IFieldState<number>,
    trialGroupItemTemplateCategoryId: IFieldState<number>,
    groupId: IFieldState<number>,
    allowIntraVersions: IFieldState<boolean>,
    initialVersion: IFieldState<string>,
    collectionId: IFieldState<number>,
    active: IFieldState<boolean>,
    dateEntered: IFieldState<string>,
    dateModified: IFieldState<string>,
    enteredBy: IFieldState<string>,
    modifiedBy: IFieldState<string>,
    message: IFieldState<string>,
    openedModals: IFieldState<string[]>
}
